var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviewWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.24992 8.625H4.33325M9.74992 8.625V10.25C9.74992 11.2716 9.74992 11.7818 9.49588 12.0993C9.25375 12.4026 8.87025 12.4161 8.12492 12.4167M9.75425 3.75H9.74884M4.33325 12.4167H3.24992C2.22834 12.4167 1.71809 12.4167 1.40067 12.0993C1.08325 11.7818 1.08325 11.2716 1.08325 10.25L1.08325 9.16667C1.08325 8.14509 1.08325 7.63484 1.40067 7.31742C1.71809 7 2.22834 7 3.24992 7H4.33325C5.35484 7 5.86509 7 6.1825 7.31742C6.49992 7.63484 6.49992 8.14509 6.49992 9.16667V10.25C6.49992 11.2716 6.49992 11.7818 6.1825 12.0993C5.86509 12.4167 5.35484 12.4167 4.33325 12.4167ZM9.74992 1.58334C8.55284 1.58334 7.58325 2.56321 7.58325 3.77167C7.58325 4.46284 7.85409 5.00017 8.39575 5.48009C8.77763 5.81863 9.24021 6.38088 9.51754 6.83588C9.65079 7.05471 9.83929 7.05471 9.98229 6.83588C10.2737 6.38954 10.7222 5.81863 11.1041 5.48063C11.6458 5.00017 11.9166 4.46284 11.9166 3.77167C11.9166 2.56375 10.947 1.58334 9.74992 1.58334Z",
    stroke: "white",
    strokeWidth: 0.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewWhite);
export default __webpack_public_path__ + "static/media/reviewWhite.a16d177b9508672a0269c8c9cd89f6bb.svg";
export { ForwardRef as ReactComponent };